/** Matches calendar backend default when body omits `reminderOffsetsMinutes`. */
export const DEFAULT_EVENT_REMINDER_OFFSETS: number[] = [15, 0];

const sortDescUnique = (offsets: number[]) =>
  [...new Set(offsets.filter((n) => Number.isInteger(n) && n >= 0 && n <= 40320))].sort((a, b) => b - a);

export const normalizeReminderOffsets = (offsets: number[]) => sortDescUnique(offsets).slice(0, 10);

/**
 * Human-readable line for agenda / popup (e.g. "Reminders: 15 min before · At start").
 */
export const formatReminderSummary = (offsets: unknown): string | null => {
  if (offsets == null) return null;
  if (!Array.isArray(offsets) || offsets.length === 0) return null;
  const nums = offsets.map((x) => Number(x)).filter((n) => Number.isInteger(n) && n >= 0);
  if (nums.length === 0) return null;
  const parts = sortDescUnique(nums).map((m) => (m === 0 ? 'At start' : `${m} min before`));
  return `Reminders: ${parts.join(' · ')}`;
};
